import { Box } from "@mui/material";

export default function SectionHeader({ left, right}) {
    return (
        <Box
         sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            bgcolor: "#fff",
            px: 2,
            py: 1.5,
            borderBottom: "1px solid #e5e7eb"
         }}
        >
            {left}
            {right}

        </Box>
    );

}